exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Source+Sans+Pro:400,400i,600,600i,700);", ""]);

// module
exports.push([module.id, ".complete.fa,.complete.fal,.complete.fas{position:relative}.complete.fa:after,.complete.fal:after,.complete.fas:after{font-family:Font Awesome\\ 5 Solid;font-size:1.2rem;left:50%;margin-left:-75%;bottom:-.5em;color:#60b8d1;color:var(--secondary-01,);content:\"\\F058\";z-index:9;position:absolute}html body [class] .text-color.text-color,html body [class] .text-color.text-color a{color:#48316b}html body [class] .line-color.line-color,html body [class] .line-color.line-color a{border-color:#60b8d1}h1,h5{color:#51226c;font-size:1.5em}.login .title{font-weight:700;margin-bottom:1rem}.login .navbar .navbar-brand.logo img{display:inline}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-fa308fc6","scoped":false,"hasInlineConfig":true}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Login/index.vue
// module id = oJ3y
// module chunks = 13 14